import { forwardRef } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

/**
 * @deprecated Please use TableRow instead
 */
const TableBaseRow = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    onClick,
    ...rest
  } = _ref;
  return jsx("tr", {
    ref: ref,
    onClick: onClick,
    role: onClick && 'button',
    ...rest,
    children: children
  });
});
TableBaseRow.displayName = 'TableBaseRow';

export { TableBaseRow };
//# sourceMappingURL=TableBaseRow.js.map
